"use client";

import * as React from "react";
import { Button } from "@/core/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/core/components/ui/dialog";
import { Maximize2 } from "lucide-react";
import { ChartRender } from "./chart-render";
import type { ChartSpec } from "../types";

export function ChartExpand({ spec }: { spec: ChartSpec }) {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <div className="relative">
        <ChartRender spec={spec} showTitle={true} />
        <Button
          variant="ghost"
          size="icon"
          className="absolute top-2 right-2 h-8 w-8 rounded-full"
          onClick={() => setOpen(true)}
          aria-label="Ampliar gráfico"
          title="Ampliar"
        >
          <Maximize2 className="h-4 w-4" />
        </Button>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-5xl bg-lightgray-200">
          <DialogHeader>
            <DialogTitle>{spec.title}</DialogTitle>
          </DialogHeader>
          <div className="mt-2">
            <ChartRender spec={spec} showTitle={false} />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
